module.exports = __webpack_public_path__ + "static/media/introTam.021462ab.jpg";